// The non-null assertions are acceptable because there definitely will always
// be data in the successful responses where the non-null assertions are made.
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { BaseQueryFn } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import { FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/dist/query';
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { BigCommerceEndpointTagTypes, Cart, CreateOrderRequest, JimboResponse } from '@models';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const cartEndpoints = (
  builder: EndpointBuilder<
    // eslint-disable-next-line @typescript-eslint/ban-types
    BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>,
    BigCommerceEndpointTagTypes,
    'bigCommerceApi'
  >,
) => {
  return {
    createCart: builder.mutation<Cart, { customerId: number; body: CreateOrderRequest }>({
      query: (query) => ({
        url: `cart/${query.customerId}`,
        method: 'POST',
        body: query.body,
      }),
      transformResponse: (response: JimboResponse<Cart>) => response.data!,
    }),
  };
};
